import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { EnrollQuery } from 'queries';
import { AttendanceStatusType } from 'types';

type Data = {
  status: AttendanceStatusType;
  count: string;
  presentHours: string;
};

const INITDATA = {
  total: 0,
  hours: 0,
  present: 0,
  late: 0,
  absent: 0,
};

function useSummary() {
  const { id } = useParams<{ id: string }>();
  const { data } = EnrollQuery.useGetSummary(id || '');

  return useMemo(() => {
    if (!data) return { ...INITDATA };

    return (data as Data[]).reduce(
      (acc, cur) => {
        acc.total += Number(cur.count || 0);

        switch (cur.status) {
          case 'PRESENT':
            acc.present += Number(cur.count || 0);
            acc.hours += Number(cur.presentHours || 0);
            break;
          case 'LATE':
            acc.late += Number(cur.count || 0);
            acc.hours += Number(cur.presentHours || 0);
            break;
          case 'ABSENT':
            acc.absent += Number(cur.count || 0);
            break;
          default:
            break;
        }

        return acc;
      },
      { ...INITDATA },
    );
  }, [data]);
}

export default useSummary;
